export var ReactionType = /*#__PURE__*/ function(ReactionType) {
    ReactionType["Heart"] = "heart";
    ReactionType["Diamond"] = "diamond";
    ReactionType["Spade"] = "spade";
    ReactionType["Club"] = "club";
    return ReactionType;
}({});
export var FocusMessageStep = /*#__PURE__*/ function(FocusMessageStep) {
    FocusMessageStep["Idle"] = "idle";
    FocusMessageStep["Fetch"] = "fetch";
    FocusMessageStep["Render"] = "render";
    FocusMessageStep["Scroll"] = "scroll";
    return FocusMessageStep;
}({});
/**
 * Because we load redux dynamically, we have to initialize a few things before our damz
 * are ready to be displayed. This enum is used to track those things (e.g. are translations initializing?)
 */ export var InitializationStatus = /*#__PURE__*/ function(InitializationStatus) {
    /**
   * We're still waiting on something (e.g. code to execute, network request to finish)
   */ InitializationStatus["Initializing"] = "initializing";
    /**
   * Initialized and ready to go!
   */ InitializationStatus["Success"] = "success";
    /**
   * Most likely we failed to load a resource due to a network issue.
   */ InitializationStatus["Failure"] = "failure";
    return InitializationStatus;
}({});
export const RoomType = {
    DM: 1,
    MULTI: 2,
    COMMUNITY: 3
};
export const RoomFlags = {
    all: 0,
    muted: 1,
    unread: 2,
    starred: 4,
    archived: 8,
    request: 16,
    watching: 32,
    supporters: 64
};
export const RoomFlagNames = {
    all: 'all',
    muted: 'muted',
    unread: 'unread',
    starred: 'starred',
    archived: 'archived',
    request: 'request',
    watching: 'watching',
    supporters: 'supporters'
};

//# sourceMappingURL=index.js.map